import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Candidates } from '../../models/candidates.model';
import { UsersService } from '../../services/users.service';
import { FunctionsService } from '../../services/functions.service';
import { HttpService } from '../../services/http.service';
import { Trainings } from '../../models/trainings.model';
import { Professions } from 'src/app/models/professions.model';
import { CandidatesProfiles } from '../../models/candidatesProfiles.model';
import { CandidatesExperiences } from 'src/app/models/candidatesExperiences.model';
import { AreaActivities } from '../../models/areaActivities.model';
import { CandidatesTrainings } from '../../models/candidatesTrainings.model';
import { CandidatesLanguages } from '../../models/candidatesLanguages.model';
import { Languages } from 'src/app/models/languages.model';
import { CandidatesSkills } from '../../models/candidatesSkills.model';
import { Skills } from '../../models/skills.model';
import { CandidatesCertificates } from 'src/app/models/candidatesCertificates.model';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-candidat-experience-update',
  templateUrl: './candidat-experience-update.component.html',
  styleUrls: ['./candidat-experience-update.component.scss']
})
export class CandidatExperienceUpdateComponent implements OnInit {

  @Input() typeInterface: string = 'candidat';
  candidates: Candidates = new Candidates([]);
  experienceIsLoading: boolean = false;
  experiencesForm: FormGroup = new FormGroup({});
  candidatesExperiences: CandidatesExperiences = new CandidatesExperiences({});
  experienceProValue: any;
  experienceList: CandidatesExperiences[] = [];
  jobIDToApply: any;
  showBtnToGoApplyJob = false;
  experienceEditing: CandidatesExperiences = new CandidatesExperiences({});
  trainingList: Trainings[] = [];
  professionList: Professions[] = [];
  candidatesProfiles: CandidatesProfiles = new CandidatesProfiles({});
  totalFillingRate = 0;
  personalInfoRate = 0;
  profileRate = 0;
  experienceRate = 0;
  trainingRate = 0;
  languageRate = 0;
  skillRate = 0;
  countryData: any;
  countryList: any[] = [];
  cityList: any[] = [];
  areaActivityList: AreaActivities[] = [];
  dateObj = new Date();
  currentMonth = (this.dateObj.getUTCMonth() + 1 < 10) ? '0' + (this.dateObj.getUTCMonth() + 1) : this.dateObj.getUTCMonth() + 1;
  currentYear = this.dateObj.getUTCFullYear();
  attestationFile: any = null;

  constructor(private router: Router, private formBuilder: FormBuilder, private usersService: UsersService, public functionsService: FunctionsService, private httpService: HttpService) {
    this.getExperienceEditing();
    if (usersService.getUserType() != 'candidat') {
      this.router.navigate(['/not-found']);
    }

    this.candidates = this.usersService.getCurrentUser();
    this.trainingList = this.functionsService.getTrainingsList();
    this.professionList = this.functionsService.getProfessionsList();

    if (localStorage.getItem('jobIDToApply') && localStorage.getItem('jobIDToApply') != undefined) {
      this.jobIDToApply = localStorage.getItem("jobIDToApply");

      this.showBtnToGoApplyJob = true;
    }
  }

  ngOnInit(): void {
    console.log(this.experienceEditing);
    this.initExperiencesForm();

  }

  getExperienceEditing() {
    if (localStorage.getItem('jobEditing') != undefined) {
      const dataString: any = localStorage.getItem('experienceEditing');
      this.experienceEditing = new CandidatesExperiences(JSON.parse(dataString));
    }
  }
  initExperiencesForm() {
    this.experienceProValue = this.experienceList.length > 0 ? true : false;
    this.areaActivityList = this.functionsService.getAreaActivitiesList();
    this.experiencesForm = this.formBuilder.group({
      candidate_experience_id: [(this.experienceEditing.getId() != undefined) ? this.experienceEditing.getId() : '', Validators.required],
      area_activity_id: ['', Validators.required],
      job_title: [(this.experienceEditing.getJobTitle() != undefined) ? this.experienceEditing.getJobTitle() : '', Validators.required],
      month_start: ['', Validators.required],
      year_start: ['', Validators.required],
      month_end: [''],
      year_end: [''],
      company: [(this.experienceEditing.getCompany() != undefined) ? this.experienceEditing.getCompany() : '', Validators.required],
      position_level: [(this.experienceEditing.getPositionLevel() != undefined) ? this.experienceEditing.getPositionLevel() : '', Validators.required],
      team_management: [(this.experienceEditing.getTeamManagement() != undefined) ? this.experienceEditing.getTeamManagement() : ''],
      supervisor_title: [(this.experienceEditing.getSupervisorTitle() != undefined) ? this.experienceEditing.getSupervisorTitle() : '', Validators.required],
      reason_for_leaving: [(this.experienceEditing.getReasonForLeaving() != undefined) ? this.experienceEditing.getReasonForLeaving() : ''],
      task_description: [(this.experienceEditing.getTaskDescription() != undefined) ? this.experienceEditing.getTaskDescription() : '', Validators.required],
      realisation: [(this.experienceEditing.getRealisation() != undefined) ? this.experienceEditing.getRealisation() : '', Validators.required],
    });
  }

  onSubmitExperienceForm(): any {
    const element: any = document.getElementById('experienceInProgress');
    let in_progress = element.checked;
    let formValue: any = this.experiencesForm.value;
    formValue['in_progress'] = (in_progress) ? 'true' : 'false';
    formValue['period_start'] = formValue.month_start + '-' + formValue.year_start;
    const monthEnd = (formValue.month_end == '') ? this.currentMonth : formValue.month_end;
    const yearEnd = (formValue.year_end == '') ? this.currentYear : formValue.year_end;
    formValue['period_end'] = monthEnd + '-' + yearEnd;
    formValue['certificate'] = this.attestationFile;

    this.experienceIsLoading = true;

    this.httpService.updateCandidateExperience(formValue, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.experienceIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Expérience mise à jour avec succès.',
          })

          this.candidates = this.usersService.getCurrentUser();
          this.initExperiencesForm();
          this.router.navigate(['/candidat-experiences']);
        }
      },
      (error) => {
        console.log(error);
        this.experienceIsLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }


  async chooseAttestation() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner le fichier',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'Fichier selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.attestationFile = file;
        Swal.fire({
          icon: 'success',
          title: 'Fichier chargé',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }

  loadCountries() {
    this.httpService.getCountries().subscribe(data => {
      this.countryData = data;
      const countries: any = data;
      let countryList: any[] = [];
      countries.find((item: { country: any; }) => {
        const country = item.country
        if (!countryList.includes(country)) {
          countryList.push(country)
        }
      });

      this.countryList = countryList.sort();

      this.cityList = this.functionsService.findCitiesOfCountry(this.candidates.getCountry(), this.countryData);
    })
  }

  onChangeCountry(country: string) {
    this.cityList = this.functionsService.findCitiesOfCountry(country, this.countryData);
  }

}



